import { render, staticRenderFns } from "./SupplyPointForm2.vue?vue&type=template&id=2ab79970&scoped=true"
import script from "./SupplyPointForm2.ts?vue&type=script&lang=ts&external"
export * from "./SupplyPointForm2.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab79970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab79970')) {
      api.createRecord('2ab79970', component.options)
    } else {
      api.reload('2ab79970', component.options)
    }
    module.hot.accept("./SupplyPointForm2.vue?vue&type=template&id=2ab79970&scoped=true", function () {
      api.rerender('2ab79970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P38/SupplyPointForm2/SupplyPointForm2.vue"
export default component.exports